import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs';

import { ConfigService } from './config.service';
import { BASE_MENU, MenuModel } from '@shared/models';

@Injectable()
export class CommonService {
  private menuList: Array<MenuModel> = [];

  constructor(
    private config: ConfigService,
    private translate: TranslateService
  ) {
    if (this.menuList === undefined) {
      this.initMenu();
    }
  }

  get isEN(): boolean {
    return (this.translate.currentLang != 'th');
  }

  get locale(): string {
    return this.translate.currentLang;
  }

  get allMenu(): Array<MenuModel> {
    return this.menuList;
  }

  private initMenu() {
    this.menuList = BASE_MENU as Array<MenuModel>;
  }

  public getOnMenu(code: string): MenuModel {
    return this.menuList.find(obj => obj.code === code) as MenuModel;
  }

  public defineMenu(): Observable<boolean> {
    return new Observable<boolean>(observer => {
      this.menuList.forEach(menu => {
        menu.active = true;
        menu.select = false;
        menu.child?.forEach((child: any) => {
          child.active = true;
          child.select = false;
        });
      });
      observer.next(true);
      observer.complete();
    });
  }
}
